import React from "react";
import { Link } from "react-router-dom";
import facebookicon from "../../images/facebook_icon.png";
import instagram from "../../images/instagram_icon.png";

const SocialMedia = () => {

    return (
        <>
            <div className="socilamedia">
                <ul>
                    <li> <p className="followus"> Follow Us  </p>  </li>
                    <li>  <a href="#" target="_black" className="instagram">  </a>    </li>
                    <li>  <a href="#" target="_black" className="facebookicon">  </a> </li>
                </ul>
            </div>
        </>
    )
};


export default SocialMedia;    